<template>
  <v-container v-if="groups.length > 0">
    <v-form>
      <v-row class="mt-n8 mb-4">
        <v-col cols="12">
          <span class="headline pb-4">{{ $t("sponsorGroup") }}</span>
        </v-col>
      </v-row>
      <v-row class="mt-n8 mb-2">
        <v-col cols="12">
          <v-select
            v-model="selectedGroupId"
            :items="groups"
            item-value="id"
            item-text="displayName"
            :label="$t('group') + ' *'"
            required
            outlined
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row class="mt-n4 mb-2" justify="end">
        <v-col cols="3" lg="2">
          <v-btn :disabled="selectedGroupId === null" @click="submit">
            {{ $t("send") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import {
  executiveProgramResource,
  executivePackagesResource,
} from "../api/resources";
export default {
  data() {
    return {
      executiveProgramUrl: "",
      groups: [],
      selectedGroupId: null,
    };
  },
  async mounted() {
    const executiveProgramResponse = await executiveProgramResource.get("");
    this.executiveProgramUrl = executiveProgramResponse.data.url;
    this.groups = (
      await executivePackagesResource(
        this.executiveProgramUrl,
        executiveProgramResponse.data.eventId,
      ).get("")
    ).data.map((group) => ({
      ...group,
      displayName: `${
        this.$i18n.locale === "de" ? group.title : group.title_en
      } (${new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(group.price / (100 + group.vat))})`,
    }));
  },
  created: function() {
    const selectButtons = document.getElementsByClassName("sponsor-select");
    for (let i = 0; i < selectButtons.length; i++) {
      selectButtons[i].addEventListener("click", this.selectGroup);
    }
  },
  destroyed: function() {
    const selectButtons = document.getElementsByClassName("sponsor-select");
    for (let i = 0; i < selectButtons.length; i++) {
      selectButtons[i].removeEventListener("click", this.selectGroup);
    }
  },
  methods: {
    selectGroup(event) {
      this.selectedGroupId = event.target.dataset.value;
    },
    submit() {
      window.open(
        `${this.executiveProgramUrl}?sponsorshipId=${this.selectedGroupId}&locale=${this.$i18n.locale}`,
        "_blank",
      );
      this.selectedGroupId = null;
    },
  },
};
</script>
